﻿import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from '../Regelverk/App';
import configureStore from '../Regelverk/Store';
import { getResult } from './Utilities/RegelApi';
import { set, setFeilmelding } from '../Regelverk/Store/Actions';

const store = configureStore();
const root = document.getElementById("regel-paragrafer");
if (root != null) {
    const tittel = root.getAttribute('data-kapitteldel')!;
    const kapittelFramtidigeEndringer = root.getAttribute('data-kapittelframtidigeendringer')!;
    const lukkLenketekst = root.getAttribute('data-lukklamell')!;
    const lukkMerknadAriaLabel = root.getAttribute('data-lukkarialabel')!;

    const contentLink = root.getAttribute('data-content')!;
    const kapittelsideGuid = root.getAttribute('data-kapittelguid')!;
    const aktivParagraf = root.getAttribute('data-aktiv')!;
    const aktivVedStart = aktivParagraf === "" ? (location.hash != "" ? location.hash.split('#')[1] : "") : aktivParagraf;

    getResult(kapittelsideGuid)
        .then((data): void => {
            store.dispatch(set({
                paragrafer: data.paragrafer,
                loading: true,
                sisteAktiveLamell: aktivVedStart,
                firstLoadReady: false,
                kapittelMerknadOverskrift: data.kapittelMerknadOverskrift,
                kapittelMerknadTekst: data.kapittelMerknadTekst,
                kapittelMerknadLenketekst: data.kapittelMerknadLenketekst,
                visFeilmelding: false,
            }));
        })
        .catch((reason: any): void => {
            console.log(reason);
            store.dispatch(setFeilmelding());
        });

    const AppRoot = () => (
        <Provider store={store}>
            <App
                tittel={tittel}
                kapittelFramtidigeEndringer={kapittelFramtidigeEndringer}
                lukkLenketekst={lukkLenketekst}
                lukkMerknadAriaLabel={lukkMerknadAriaLabel}
                contentLink={contentLink}
                aktivVedStart={aktivParagraf}
            />
        </Provider>
    );

    ReactDOM.createRoot(root).render(<AppRoot />);
}
